import {Component, ElementRef, EventEmitter, HostBinding, Output, ViewChild, ViewContainerRef} from '@angular/core';
import { Router } from '@angular/router';

import {SimpleDialect} from "../../shared/models/dialect.model";
import {DialectBookmarkService} from "../../shared/services/dialect/dialect-bookmark.service";
import {DialectItemComponent} from "../../shared/components/dialect-item/dialect-item.component";
import {DialectHistoryService} from "../../shared/services/dialect/dialect-history.service";
import {GlobalEventService} from "../../shared/services/global-event/global-event.service";
import {DynamicComponentService} from "../../shared/services/dynamic-component/dynamic-component.service";

@Component({
  selector: 'app-dialect-item-head',
  templateUrl: './dialect-item-head.component.html',
  styleUrls: ['./dialect-item-head.component.scss']
})
export class DialectItemHeadComponent extends DialectItemComponent {
  @HostBinding('class') override class = 'word-item-head-box';
  @HostBinding('style.display') styleBlock = 'block';
  // @ViewChild('container', {read: ViewContainerRef, static: true}) override container!: ViewContainerRef;
  @ViewChild('container', {read: ViewContainerRef}) override container!: ViewContainerRef;
  @Output() open = new EventEmitter<SimpleDialect>();

  constructor(
    public override router: Router,
    public override dHistorySvc: DialectHistoryService,
    public override dynamicSvc: DynamicComponentService,
    protected override bmSvc: DialectBookmarkService,
    protected override globalEventSvc: GlobalEventService,
    public elRef: ElementRef,
  ) {
    super(router, dHistorySvc, dynamicSvc, bmSvc, globalEventSvc);
  }

  protected onOpen($event: MouseEvent) {
    $event.preventDefault();
    $event.stopPropagation();
    this.globalEventSvc.Click($event, true);

    if (this.dialect === null) {
      throw new Error('DialectItemHeadComponent::onOpen() Dialect is null');
    }
    this.open.emit(this.dialect);
  }

}
